export default class DataSetColEnumEditor
{
	name = "";
    label = "";
    visible = true;
    helpText = null;
    displayLength = 20;
    alignment = "Center";
    enumItems =[];
    type  = "Enum";
}


// WEBPACK FOOTER //
// ./src/universalView/dataSet/DataSetColEnumEditor.js